import FeaturesServiceJr from '../_raw/features/icon_features_service_jr.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FeaturesServiceJr, { shouldSetDefaultSize: false });
